<template>
  <div class="bar-options-data-dialog colorfff6">
    <div class="setting-item">
      <el-collapse v-model="activeNames">
        <el-collapse-item @mousedown.native="collapseMouseDown($event, '1')" title="数据源" name="1">
          <div class="data-source-type">
            <cx-slider :value.sync="noCacheComponent" :options="dataOptions" :height="32" />
            <div v-show="noCacheComponent">
              <data-center-choose 
                :checkStatus="checkStatus"
                :myId="ids"
                :options="options"
                class="mt12"
                @onDataCenterChange="onDataCenterChange"
                @onAfterDataCenterChoose="onAfterDataCenterChoose"
              />
            </div>
            <div  v-show="!noCacheComponent" class="dataSource-item mt12" @click="goToChooseData">
               <span>进入数据管理后台 </span>
           </div>
          </div>
        </el-collapse-item>
        <el-collapse-item
          v-if="!noCacheComponent"
          class="dataContent"
          @mousedown.native="collapseMouseDown($event, '2')"
          title="数据内容"
          name="2"
        >
          <tableSourceData
            :headerData="options.headerData"
            :listData="options.listData"
            :options="options"
          />
        </el-collapse-item>
        <el-collapse-item v-show="noCacheComponent" @mousedown.native="collapseMouseDown($event, '3')" title="更多" name="3">
          <div class="data-source-type">
            <auto-update-timer/>
            <!-- <div class="getDataBtn mt12" @click="getBaseModuleDataLoop">查看数据响应结果</div> -->
            <cx-check-box  v-if="request_prefix==='bigScreen'"  :value.sync="usePageQuery">开启跨页面传参</cx-check-box>
            <!-- 点击表格行跳转的设置 -->
            <div class="mt12" v-if="hasClickPluign">
              <cx-check-box :value.sync="selectPageQuery">开启动态参数</cx-check-box>
              <div v-if="selectPageQuery">
                <cx-select class="mt12" :value.sync="trQueryValue" :selectOptions="filedMappingList" title="传参设置" />
                <div class="variable_set mt12">
                  <div class="mr8 name">页面地址</div>
                  <el-input
                    class="variable_value"
                    v-model="linkUrlVal"
                    placeholder="请输入http://或https://开头的地址"
                  ></el-input>
                </div>
                <div class="content-item mt12 verticallyCenter clearFloat">
                  <div class="font14 mr8 no-break">跳转至</div>
                  <el-radio-group v-model="openBlankPage">
                    <el-radio label="新页面">新页面</el-radio>
                    <el-radio label="当前页面">当前页面</el-radio>
                  </el-radio-group>
                </div>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import tableSourceData from "./tableSourceData"
import autoUpdateTimer from "components/toolbar-option-components/utilsComponents/autoUpdateTimer/autoUpdateTimer.vue"
import dataCenterChoose from "publicSetting/dataCenterChoose.vue"
export default {
  name: "table-options-data",
  components: { tableSourceData, autoUpdateTimer, dataCenterChoose },
  props: {
    options: {
      type: Object
    }
  },
  data() {
    return {
      this1: this,
      labelTrue: true,
      labelFalse: false,
      activeNames: ["1", "2"],
      collapseActiveNames: [],
      interval: 3,
      activeIndex: 0,
      editingFlag: false,
      oprateShow: false,
      fetchEnd: false,
      dataOptions: [{ value: false, title: "本地数据" }, { value: true, title: "数据中心" }]
    }
  },
  mounted() {
    this.$nextTick(() => {
      // 关闭操作下拉列表
      document.getElementsByClassName("right-toolbar")[0].addEventListener("click", this.closeOpration)
      document.addEventListener("click", this.closeOpration)
    })
    this.$eventBus.$on("update-toolbar-data", this.updateToolbarData)
  },
  beforeDestroy() {
    document.getElementsByClassName("right-toolbar")[0].removeEventListener("click", this.closeOpration)
    document.removeEventListener("click", this.closeOpration)
    window.removeEventListener("storage", this.listenStorage)
    this.$eventBus.$off("update-toolbar-data", this.updateToolbarData)
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    usePageQuery: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "usePageQuery", "usePageQuery", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "usePageQuery", false)
      }
    },
    noCacheComponent: {
      get() {
        return this.options && this.options.noCacheComponent ? this.options.noCacheComponent : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "noCacheComponent", false, null)
      }
    },
    restDataUrl: {
      get() {
        return this.options && this.options.restDataUrl ? this.options.restDataUrl : null
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "restDataUrl", false)
      }
    },
    filedMappingList: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "filedMappingList", "filedMappingList", [])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "filedMappingList", false, null)
      }
    },
    selectPageQuery: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "selectPageQuery", "selectPageQuery", false)
      },
      set(newVal) {
        if (!newVal) {
          this.$changeOptionsEV(["", "", newVal], ["trQueryValue", "linkUrlVal", "selectPageQuery"], false)
        } else {
          this.$changeOptionsEV(newVal, "selectPageQuery", false)
        }
      }
    },
    trQueryValue: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "trQueryValue", "trQueryValue", "")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "trQueryValue", false)
      }
    },
    openBlankPage: {
      get() {
        return this.options.openBlankPage ? "新页面" : "当前页面"
      },
      set(newVal) {
        let temp = true
        if (newVal == "新页面") {
          temp = true
        } else {
          temp = false
        }
        this.$changeOptionsEV(temp, "openBlankPage", false)
      }
    },
    linkUrlVal: {
      get() {
        return this.options.linkUrlVal || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "linkUrlVal", false)
      }
    },
    hasClickPluign() {
      if (
        this.options.pluginName?.length > 0 &&
        this.options.pluginName.indexOf("selectQueryClickJumpToSpecialUrl") !== -1
      ) {
        return true
      } else {
        return false
      }
    },
    checkStatus() {
      return this.options.appId
    }
  },
  methods: {
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    goToChooseData() {
      if (this.fetchEnd) return
      this.fetchEnd = true
      const { websiteId, pageId, sign, wfwfid, homePageId, pageType } = this.$store.state.states.getDataPageIds
      const rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], this.ids)
      let { moduleId, appId } = rectAttr
      if (moduleId === undefined) moduleId = rectAttr?.options?.moduleId
      if (appId === undefined) appId = rectAttr?.options?.appId
      if (!!!moduleId || !!!appId) {
        this.$saveModule(this.ids, "31CB73E03E24BBFF", "临时")
          .then(res => {
            this.fetchEnd = false
            if (!!res.appId) {
              window.open(`/engine2/data/api-v2/admin/general/${res.appId}?w=${websiteId}&p=${pageId}&init=1`)
            }
          })
          .catch(err => (this.fetchEnd = false))
      }
      this.fetchEnd = false
      if (!!appId) window.open(`/engine2/data/api-v2/admin/general/${appId}?w=${websiteId}&p=${pageId}`)
      // 数据自动渲染
      window.addEventListener("storage", this.listenStorage)
    },
    async getBaseModuleDataLoop() {
      if (!this.checkStatus) {
        return
      }
      /**
       * 表格需要对返回数据为空的情况做特殊处理
       */
      this.updateNormalRect
        .call(
          this,
          datas => {
            // 组装数据
            const sourceData = datas
            let headerData = [] //表头数据
            let listData = [] //表格内容
            let listOtherData = [] // 表格额外内容
            for (let i = 0; i < sourceData.length; i++) {
              let param = []
              let otherParam = {}
              Object.keys(sourceData[i]).forEach(item => {
                // 防止添加重复的表头数据
                if (
                  typeof sourceData[i][item] == "object" &&
                  sourceData[i][item] !== null &&
                  sourceData[i][item] !== undefined
                ) {
                  if (!headerData.includes(sourceData[i][item].key)) {
                    headerData.push(sourceData[i][item].key)
                  }
                  param.push(sourceData[i][item].value)
                } else {
                  otherParam[item] = sourceData[i][item]
                }
              })
              listData.push(param)
              listOtherData.push(otherParam)
            }
            if (this.options.isShowSerialNumber) {
              let serialNumberHeaderData = []
              for (let i = 0; i < headerData.length; i++) {
                let param
                if (this.options.serialNumberHeaderData && this.options.serialNumberHeaderData[i]) {
                  param = {
                    ...this.options.serialNumberHeaderData[i],
                    value: headerData[i] // 列名
                  }
                } else {
                  param = {
                    value: headerData[i], // 列名
                    align: "center", // 内容对齐方式 "left/center/right"
                    type: "text", // 字段显示方式 "text/image"
                    isDesensitization: false, // 是否脱敏
                    width: 20,
                    height: 20,
                    borderRadius: 6,
                    fontSize: 12,
                    fontFamily: "sans-serif",
                    fontWeight: "400",
                    fontColor: "rgba(255, 255, 255, 0.8)"
                  }
                }
                serialNumberHeaderData.push(param)
              }
              this.$changeOptionsEV(serialNumberHeaderData, "serialNumberHeaderData", false, false, false, true)
            }
            this.$changeOptionsEV(headerData, "headerData", false, false, false, true)
            this.$changeOptionsEV(listData, "listData", false, false, false, true)
            this.$changeOptionsEV(listOtherData, "listOtherData", false, false, false, true)
            // 组装字段映射的数据结构
            let list = []
            Object.keys(sourceData[0]).forEach((key, index) => {
              if (
                key !== "url" &&
                key !== "publicId" &&
                key !== "id" &&
                key !== "pageType" &&
                key !== "pop" &&
                key !== "dataUrl" &&
                key !== "popUrl" &&
                key !== "pckedDetail" &&
                key !== "content"
              ) {
                const temp = {
                  value: key,
                  label: sourceData[0][key]?.key
                }
                list.push(temp)
              }
            })
            this.filedMappingList = list
          },
          50
        )
        .then(restDataUrl => {
          this.restDataUrl = restDataUrl
        })
        .catch(e => {
          if (e === "接口数据为空") {
            this.$changeOptionsEV([], "listData", false, false, false, true)
          }
        })
    },
    closeOpration() {
      this.oprateShow = false
    },
    listenStorage(e) {
      if (e.key == "page-v2-data-update") {
        // 后台配置或数据更新
        console.log("后台配置或数据更新 :>>")
        this.getBaseModuleDataLoop()
      }
    },
    onDataCenterChange() {
      this.getBaseModuleDataLoop()
    },
    onAfterDataCenterChoose() {
      window.addEventListener("storage", this.listenStorage)
    },
    updateToolbarData() {
      this.getBaseModuleDataLoop()
    }
  }
}
</script>

<style lang="scss" scoped>
.title500_16_22 {
  color: inherit;
}
.data-source-type {
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.data-source-type::v-deep .el-radio {
  margin-bottom: 16px;
}
.data-source-type::v-deep .el-radio__inner {
  background-color: rgba(255, 255, 255, 0);
}
.dataContent {
  font-size: 14px;
  line-height: 22px;
  color: rgba(255, 255, 255, 0.8);
}
.getDataBtn {
  background: var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  padding: 6px 0px;
}
.getDataBtn:hover {
  cursor: pointer;
}
.dataSource-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  background: var(--leftMenuBgColor);
  border: 1px solid var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  color: var(--themeColor);
  &:hover {
    cursor: pointer;
  }
}
.dataUrl-item input {
  width: 252px;
  height: 32px;
  background: #35383f;
  color: rgba(255, 255, 255, 0.2);
}
.dataUrl-item .tips {
  color: var(--fourthTextColor);
}
.dataTabs {
  width: 276px;
  display: flex;
  border-top: 1px solid #41474f;
}
.dataTabs .dataTabItem {
  font-size: 13px;
  line-height: 22px;
  color: #ffffff;
  background: #2d3136;
  padding: 7px 8px 7px 13px;
  cursor: pointer;
  border-right: 1px solid rgba(255, 255, 255, 0.08);
  position: relative;
}
.dataTabs .dataTabItem.active {
  background: #41474f;
}
.dataTabs .dataTabItem .value-viewer {
  margin-right: 6px;
}
.dataTabs .addClassification {
  padding: 12px 16px;
  cursor: pointer;
  text-align: center;
  background: #2d3136;
  border-right: 1px solid rgba(255, 255, 255, 0.08);
}
.dataTableOperate {
  position: absolute;
  bottom: 40px;
  left: 0;
}
.dataTableOperate_item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 12px;
  width: 72px;
  height: 40px;
  background: #1f2124;
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  line-height: 24px;
  cursor: pointer;
}
.dataTabs .data-editor {
  display: block;
  box-sizing: border-box;
  height: 24px;
  line-height: 24px;
  width: 84px;
  text-align: left;
  padding: 0 2px;
  overflow: hidden;
  white-space: nowrap;
  background: none;
  outline: none !important;
  border: 0;
  color: #ffffff;
}
</style>
